import { login, registerArtistWithApplication, logout, forgotPassword, changePassword, getDetailUser, acceptToc } from '@/services/auth';

export default {
  async requestAuthentication({ commit, dispatch }, { user, isAdmin = false }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let response;
    let isUpdateTnc = false;
    try {
      response = await login(user, isAdmin);
      localStorage.setItem('access_token', response.data.access_token);
      localStorage.setItem('token_type', response.data.token_type);
      localStorage.setItem('expires_in', response.data.expires_in);
      localStorage.setItem('role', response.data.user.role);
      if (typeof (response.data.tnc) !== 'undefined') {
        localStorage.setItem('isUpdateTnc', response.data.tnc.updated);
        isUpdateTnc = response.data.tnc.updated;
      }
      commit('SET_AUTH', { accessToken: response.data.access_token, tokenType: response.data.token_type, expiresIn: response.data.expires_in, role: response.data.user.role, isUpdateTnc });
      dispatch('requestDetailUser');
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message} : ${user.email}`, errorCode: 'ER-AUTH-02' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return response;
  },
  async createAuthentication({ commit }, formData) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let response;
    try {
      await registerArtistWithApplication(formData);
      response = { status: true, msg: '' };
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: err.data.message, errorCode: 'ER-AUTH-01' }, { root: true });
      response = { status: false, msg: err.data.message };
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return response;
  },
  async removeAuthentication({ commit }, dataAuth) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let response;
    try {
      response = await logout(dataAuth.accessToken, dataAuth.tokenType);
      localStorage.removeItem('access_token');
      localStorage.removeItem('token_type');
      localStorage.removeItem('expires_in');
      localStorage.removeItem('user');
      localStorage.removeItem('role');
      localStorage.removeItem('isUpdateTnc');
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'ER-AUTH-03' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return response;
  },
  // eslint-disable-next-line no-unused-vars
  async requestForgotPassword({ commit }, email) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      // TODO : call service to request Forgot Password
      await forgotPassword({ email });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'ER-AUTH-03' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  // eslint-disable-next-line no-unused-vars
  async requestChangePassword({ commit }, user) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      // TODO : call service to request Change password
      await changePassword(user);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'ER-AUTH-03' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },

  async requestDetailUser({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const authorization = { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] };
      const user = await getDetailUser(authorization);
      localStorage.setItem('user', JSON.stringify(user));
      commit('SET_USER', { user });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'ER-AUTH-03' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },

  async acceptToc({ commit, rootGetters }, email) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const authorization = { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] };
      const user = await acceptToc(email, authorization);
      localStorage.setItem('user', JSON.stringify(user));
      commit('SET_USER', { user });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'ER-AUTH-03' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },

};



// WEBPACK FOOTER //
// ./src/stores/Auth/actions/index.js